import { render, staticRenderFns } from "./BackEnd.vue?vue&type=template&id=73d271ad&scoped=true"
import script from "./BackEnd.vue?vue&type=script&setup=true&lang=js"
export * from "./BackEnd.vue?vue&type=script&setup=true&lang=js"
import style0 from "./BackEnd.vue?vue&type=style&index=0&id=73d271ad&prod&lang=css"
import style1 from "./BackEnd.vue?vue&type=style&index=1&id=73d271ad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d271ad",
  null
  
)

export default component.exports